import React from "react";
import SandAHead from "../../component/SandAHead/SandAHead";

const SandA = () => {
  const goals = Array.from({ length: 17 }, (_, index) => index + 1);

  return (
    <div>
      <SandAHead />
      {/* Goals  */}
      <div class="contente">
        <div className="row">
          {" "}
          {goals.map((goalNumber) => (
            <div
              key={goalNumber}
              className={`carde card-goal goal-${goalNumber} col-6 col-sm-6 col-md-4 col-lg-3 col-xl-2`}
            >
              <div className="card-body">
                <button type="button" className="btan btn-goal">
                  Learn More
                </button>
              </div>
              <img
                // src={require(`../assets/`)}
                src={
                  process.env.PUBLIC_URL +
                  `/assets/img/goals/goal${goalNumber}.jpg`
                }
                alt={`goal ${goalNumber} logo`}
                className="goal-logo"
              />
            </div>
          ))}
        </div>
      </div>
      {/* Goals  */}
    </div>
  );
};

export default SandA;
